import SignInForm from '../authentication/SignInForm';
import AuthSimpleLayout from '../../layouts/AuthLayout';

const SignIn = () => {
  return (
    <AuthSimpleLayout>
      <SignInForm layout="simple" />
    </AuthSimpleLayout>
  );
};

export default SignIn;
